var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"reports-page"},[_c('app-page-header',{attrs:{"title":"Relatórios"}}),_c('reports-table',{ref:"reportsTable"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }